<template>
  <div v-show="isCurrentUserFetched" :class="$style.auth">
    <client-only>
      <Login />
    </client-only>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Login from '@/components/Login/Login.vue'

export default {
  name: 'Auth',
  components: {
    Login,
  },

  computed: {
    ...mapState('account', ['isCurrentUserFetched']),
  },
}
</script>

<style lang="scss" module>
@import '@/components/SiteContainer/site-container-settings';

.auth {
  @include floating-site-content-padding;
  display: flex;
  width: 100%;
}
</style>
